<template>    
      <div class="iq-sidebar  sidebar-default ">
          <div id="sidebar-scrollbar">
              <nav class="iq-sidebar-menu">
                  <ul id="iq-sidebar-toggle" class="iq-menu">
                    <li :class="{active: isOnHomeFeed}">
                        <router-link to="/">
                            <i class="las la-newspaper"></i><span>Newsfeed</span>
                        </router-link>
                    </li>
                    <li :class="{active: cat_id==1 && !isOnHomeFeed}">
                        <a href="/category/1">
                        <i class="la la-bitcoin"></i><span>Finance</span>
                        </a>
                    </li>                      
                    <li :class="{active: cat_id==2 && !isOnHomeFeed}">
                        <a href="/category/2">
                        <i class="la la-microchip"></i><span>Technology</span>
                        </a>
                    </li>                                            
                    <li :class="{active: cat_id==3 && !isOnHomeFeed}">
                        <a href="/category/3">
                        <i class="la la-bible"></i><span>Gospel</span>
                        </a>
                    </li>                      
                    <li :class="{active: cat_id==4 && !isOnHomeFeed}">
                        <a href="/category/4">
                        <i class="la la-tshirt"></i><span>Fashion</span>
                        </a>
                    </li>                                          
                    <li :class="{active: cat_id==5 && !isOnHomeFeed}">
                        <a href="/category/5">
                        <i class="la la-laugh"></i><span>Comedy</span>
                        </a>
                    </li>                                         
                    <li :class="{active: cat_id==6 && !isOnHomeFeed}">
                        <a href="/category/6">
                        <i class="la la-graduation-cap"></i><span>Education</span>
                        </a>
                    </li>                                            
                    <li :class="{active: cat_id==7 && !isOnHomeFeed}">
                        <a href="/category/7">
                        <i class="la la-child"></i><span>Children</span>
                        </a>
                    </li>                                                         
                    <li :class="{active: cat_id==8 && !isOnHomeFeed}">
                        <a href="/category/8">
                        <i class="las la-user"></i><span>News</span>
                        </a>
                    </li>                                       
                    <li :class="{active: cat_id==9 && !isOnHomeFeed}">
                        <a href="/category/9">
                        <i class="la la-user-secret"></i><span>Agencies</span>
                        </a>
                    </li>                                
                    <li :class="{active: cat_id==10 && !isOnHomeFeed}">
                        <a href="/category/10">
                        <i class="la la-city"></i><span>Real Estate</span>
                        </a>
                    </li>                                            
                    <li :class="{active: cat_id==11 && !isOnHomeFeed}">
                        <a href="/category/11">
                        <i class="la la-tv"></i><span>Television</span>
                        </a>
                    </li>                                            
                    <li :class="{active: cat_id==12 && !isOnHomeFeed}">
                        <a href="/category/12">
                        <i class="la la-gamepad"></i><span>Gaming</span>
                        </a>
                    </li>                                            
                    <li :class="{active: cat_id==13 && !isOnHomeFeed}">
                        <a href="/category/13">
                        <i class="la la-film"></i><span>Movies</span>
                        </a>
                    </li>                      
                    <li :class="{active: cat_id==14 && !isOnHomeFeed}">
                        <a href="/category/14">
                        <i class="la la-star"></i><span>People</span>
                        </a>
                    </li>                      
                    <li :class="{active: cat_id==15 && !isOnHomeFeed}">
                        <a href="/category/15">
                        <i class="la la-truck"></i><span>Autos</span>
                        </a>
                    </li>                                            
                    <li :class="{active: cat_id==16 && !isOnHomeFeed}">
                        <a href="/category/16">
                        <i class="la la-cookie"></i><span>Cooking</span>
                        </a>
                    </li>                      
                    <li :class="{active: cat_id==17 && !isOnHomeFeed}">
                        <a href="/category/17">
                        <i class="la la-stethoscope"></i><span>Health</span>
                        </a>
                    </li>                                         
                    <li :class="{active: cat_id==18 && !isOnHomeFeed}">
                        <a href="/category/18">
                        <i class="la la-music"></i><span>Music</span>
                        </a>
                    </li>                                        
                    <li :class="{active: cat_id==19 && !isOnHomeFeed}">
                        <a href="/category/19">
                        <i class="la la-biking"></i><span>Sports</span>
                        </a>
                    </li>                                                              
                    <li class="">
                        <a href="/explorer">
                            <i class="las la-compass"></i><span>Explore</span>
                        </a>
                    </li>                                       
                  </ul>
                  </nav>
                  <div class="p-5"></div>
              </div>
          </div>
      
        <div class="iq-top-navbar">
          <div class="iq-navbar-custom">
              <nav class="navbar navbar-expand-lg navbar-light p-0">
                  <div class="iq-navbar-logo d-flex justify-content-between">
                      <router-link to="/" v-on:click="load_more_posts">
                          <img src="https://tshaku.com/view/socialV/assets/images/logo.png" class="img-fluid" alt="">
                          <span>Tshaku</span>
                      </router-link>
                      <div class="iq-menu-bt align-self-center">
                          <div class="wrapper-menu">
                              <div class="main-circle"><i class="ri-menu-line"></i></div>
                          </div>
                      </div>
                  </div>
                  <div class="iq-search-bar device-search">
                      <form @submit.prevent="search" class="searchbox">
                          <a class="search-link" href="#"><i class="ri-search-line"></i></a>
                          <input type="text" v-model="search_query" class="text search-input" style="color:#fff; -webkit-text-fill-color: rgba(255, 255, 255, 1); -webkit-opacity: 1;" placeholder="Search here...">
                      </form>
                        
                  </div>
                  <div class="device-search">
                  <!-- Mobile Search Toggle Button -->
                    <button class="mobile-search-toggle" @click="openSearch = true"><i class="ri-search-line" style="color:#50b5ff;"></i></button>
                    <!-- Mobile Search Modal -->
                    <div v-if="openSearch && isMobile" class="mobile-search-modal" @click.self="closeSearch">
                        <div class="mobile-search-box">
                            <form @submit.prevent="search">
                                <input type="text" v-model="search_query" placeholder="Search..." autofocus/>
                                <button type="submit"><i class="ri-search-line"></i></button>
                            </form>
                        </div>
                    </div>                      
                    <!-- End Mobile search -->
                </div>
                  <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                      data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                      aria-label="Toggle navigation">
                      <i class="ri-menu-3-line"></i>
                  </button>
                  <div class="collapse navbar-collapse" id="navbarSupportedContent">
                      <ul class="navbar-nav  ms-auto navbar-list">
                          <li>
                              <router-link to="/" class="d-flex align-items-center">
                                  <i class="ri-home-line"></i>
                              </router-link>
                          </li>
                          <li class="nav-item dropdown" v-if="isloggedin">
                            <a href="#" class="dropdown-toggle" id="group-drop" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="ri-group-line"></i></a>
                            <div class="sub-drop sub-drop-large dropdown-menu" aria-labelledby="group-drop">
                                <div class="card shadow-none m-0">
                                  <div class="card-header d-flex justify-content-between bg-primary">
                                      <div class="header-title">
                                        <h5 class="mb-0 text-white">Friend Request</h5>
                                      </div>
                                      <small class="badge  bg-light text-dark " id="num_friend_requests">0</small>
                                  </div>
                                  <div class="card-body p-0" id="friend_request_area">
                                    
                                    <div class="text-center">
                                        <a href="#" class=" btn text-primary">View More Request</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                          </li>
                          <li class="nav-item dropdown" v-if="isloggedin">
                                <a href="#" class="search-toggle   dropdown-toggle" id="notification-drop" data-bs-toggle="dropdown">
                                    <i class="ri-notification-4-line"></i>
                                </a>
                                <div class="sub-drop dropdown-menu" aria-labelledby="notification-drop">
                                    <div class="card shadow-none m-0">
                                        <div class="card-header d-flex justify-content-between bg-primary">
                                            <div class="header-title bg-primary">
                                                <h5 class="mb-0 text-white">All Notifications</h5>
                                            </div>
                                            <small class="badge  bg-light text-dark" id="num_notifications">0</small>
                                        </div>
                                        <div class="card-body p-0" id="notification_area">
                                            
                                        </div>
                                    </div>
                                </div>
                          </li>
                          <li class="nav-item dropdown" v-if="isloggedin">
                                <a href="#" class="dropdown-toggle" id="mail-drop" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="ri-mail-line"></i>
                                </a>
                                <div class="sub-drop dropdown-menu" aria-labelledby="mail-drop">
                                <div class="card shadow-none m-0">
                                    <div class="card-header d-flex justify-content-between bg-primary">
                                    <div class="header-title bg-primary">
                                        <h5 class="mb-0 text-white">Latest Messages</h5>
                                    </div>
                                    <small class="badge bg-light text-dark" id="num_messages">{{ conversations.length }}</small>
                                    </div>
                                    <div class="card-body p-0" id="messages_area">
                                        <a v-for="conv in conversations" :key="conv.id" :href="'/chat/' +getOtherUserId(conv.chatId)" class="iq-sub-card">
                                        <div class="d-flex align-items-center">
                                        <div>
                                            <img
                                            class="avatar-40 rounded"
                                            :src="conv.avatar || 'view/socialV/assets/images/user/default-avatar.png'"
                                            alt=""
                                            />
                                        </div>
                                        <div class="w-100 ms-3">
                                            <h6 class="mb-0">{{ conv.name }}</h6>
                                            <small class="float-left font-size-12">
                                            
                                            </small>
                                        </div>
                                        </div>
                                    </a>
                                    </div>
                                </div>
                            </div>
                                
                            </li>
                           <li class="nav-item dropdown">
                              <a href="#" class="   d-flex align-items-center dropdown-toggle" id="drop-down-arrow" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  <img :src="avatar" class="img-fluid rounded-circle me-3" alt="user">
                                  <div class="caption">
                                      <h6 class="mb-0 line-height">{{f_name}} {{l_name}}</h6>
                                  </div>
                              </a>
                              <div class="sub-drop dropdown-menu caption-menu" aria-labelledby="drop-down-arrow">
                                  <div class="card shadow-none m-0">
                                       <div class="card-header  bg-primary">
                                          <div class="header-title">
                                              <h5 class="mb-0 text-white">Hello {{f_name}} {{l_name}}</h5>
                                              <span class="text-white font-size-12">Available</span>
                                          </div>
                                      </div>
                                      <div v-if="isloggedin" class="card-body p-0 ">
                                          <router-link :to="'/profile/'+id" class="iq-sub-card iq-bg-primary-hover">
                                              <div class="d-flex align-items-center">
                                                  <div class="rounded card-icon bg-soft-primary">
                                                      <i class="ri-file-user-line"></i>
                                                  </div>
                                                  <div class="ms-3">
                                                      <h6 class="mb-0 ">My Profile</h6>
                                                      <p class="mb-0 font-size-12">View personal profile details.</p>
                                                  </div>
                                              </div>
                                          </router-link>
                                          <router-link to="/profile/edit" class="iq-sub-card iq-bg-warning-hover">
                                              <div class="d-flex align-items-center">
                                                  <div class="rounded card-icon bg-soft-warning">
                                                      <i class="ri-profile-line"></i>
                                                  </div>
                                                  <div class="ms-3">
                                                      <h6 class="mb-0 ">Edit Profile</h6>
                                                      <p class="mb-0 font-size-12">Modify your personal details.</p>
                                                  </div>
                                              </div>
                                          </router-link>
                                          <a href="#" class="iq-sub-card iq-bg-info-hover">
                                              <div class="d-flex align-items-center">
                                                  <div class="rounded card-icon bg-soft-info">
                                                      <i class="ri-account-box-line"></i>
                                                  </div>
                                                  <div class="ms-3">
                                                      <h6 class="mb-0 ">Account settings</h6>
                                                      <p class="mb-0 font-size-12">Manage your account parameters.</p>
                                                  </div>
                                              </div>
                                          </a>
                                          <a href="#" class="iq-sub-card iq-bg-danger-hover">
                                              <div class="d-flex align-items-center">
                                                  <div class="rounded card-icon bg-soft-danger">
                                                      <i class="ri-lock-line"></i>
                                                  </div>
                                                  <div class="ms-3">
                                                      <h6 class="mb-0 ">Privacy Settings</h6>
                                                      <p class="mb-0 font-size-12">Control your privacy parameters.
                                                      </p>
                                                  </div>
                                              </div>
                                          </a>
                                          <div class="d-inline-block w-100 text-center p-3">
                                              <a class="btn btn-primary iq-sign-btn" @click="logout" role="button">Sign out<i class="ri-login-box-line ms-2"></i></a>
                                          </div>
                                      </div>
                                      <div v-else class="card-body p-0 ">

                                          <div class="d-inline-block w-100 text-center p-3">
                                              <a class="btn btn-primary iq-sign-btn" href="/" role="button">Sign in<i class="ri-login-box-line ms-2"></i></a>
                                          </div>
                                      </div>                                      
                                  </div>
                              </div>
                          </li>
                      </ul>               
                  </div>
              </nav>
          </div>
      </div>
      
      <div class="right-sidebar-mini">
           <div class="right-sidebar-panel p-0">
              <div class="card shadow-none">
                 <div v-if="isloggedin" class="card-body p-0">
                    <div class="media-height p-3" data-scrollbar="init">
                        <div v-if="loading">Loading..</div>
                        <div v-else-if="error">{{ error }}</div>
                        <span v-else>

                            <div v-for="user in onlineUsers" :key="user.id" class="d-flex align-items-center mb-4">
                                <div class="iq-profile-avatar status-online">
                                    <a :href="'/chat/'+user.id"><img class="rounded-circle avatar-50" :src="isUrl(user.avatar) ? user.avatar : 'https://tshaku.com/'+user.avatar" alt=""></a>
                                </div>
                                <div class="ms-3">
                                    <h6 class="mb-0">{{user.first_name}} {{user.last_name}}</h6>
                                    <p class="mb-0">Just Now</p>
                                </div>
                            </div>
                        </span>
                    </div>
                    <div class="right-sidebar-toggle bg-primary text-white mt-3">
                       <i class="ri-arrow-left-line side-left-icon"></i>
                       <i class="ri-arrow-right-line side-right-icon"><span class="ms-3 d-inline-block">Close Menu</span></i>
                    </div>                    
                 </div>
              </div>
           </div>
        </div>                
        <!-- CONTENT PAGE START -->  
</template>
<script>
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
  doc,
  getDoc
} from 'firebase/firestore';
import { db } from '../../firebase';
import axios from 'axios'
export default {
    name : 'ContentHeader',
    data(){
        return {             
            openSearch: false,
            isMobile: false,           
            search_query:null,
            conversations: [],
            onlineUsers:[],
            loading:false,
            error:null
            //id: this.$store.state.userId, // or however you access the current user's ID
        }
    },
    computed : {
        isOnHomeFeed(){
            let path =window.location.pathname
            if(path=='/'){
                return true;
            }
            else{
                return false;
            }
        },        
        isloggedin(){
            var token=localStorage.getItem('token')
            if(!token){
                return false
            }
            else{
                return true;
            }
        },
        cat_id(){
            return this.$store.state.cat_id
        },
        id(){
            return this.$store.state.userId
        },
        f_name(){
            return this.$store.state.firstName
        },
        l_name(){
            return this.$store.state.lastName
        },
        avatar(){
            return this.$store.state.avatar
        }
    },
    props: [],
    watch: { 
    },
    methods : { 
        search(){
            this.closeSearch();
            this.$router.push('/search/'+this.search_query)            
        },
        closeSearch() {
            this.openSearch = false;
        },
        handleResize() {
            this.isMobile = window.innerWidth < 768;
        },
        handleKeyDown(e) {
            if (e.key === 'Escape') this.closeSearch();
        },
        isUrl(avatar){
            try{
                new URL(avatar);
                return true;
            } catch (_){
                return false;
            }
        },
        async fetchOnlineUsers(){
            this.loading=true;
            try{
                const response = await axios.get('api.php?action=online');                
                this.onlineUsers = response.data;
            } catch (err) {
                this.error = 'Failed to load online users';
                console.log(err);
            } finally {
                this.loading = false;
            }
        },
        getOtherUserId(chatId) {
            const parts = chatId.split('_');
            return parts.find(uid => uid !== this.id);
        }, 
        async fetchLatestConversations() {
            if (!this.id){
                //alert('Not found')
                return;
            } 
            try {
                const conversationsRef = collection(db, 'conversations');

                const q = query(
                    conversationsRef,
                    where('participants', 'array-contains', this.id),
                    orderBy('lastUpdated', 'desc'),
                    limit(5)
                );

                const snapshot = await getDocs(q);
                const conversationList = [];

                for (const docSnap of snapshot.docs) {
                    const data = docSnap.data();
                    const otherUserId = data.participants.find(uid => uid !== this.id);

                    let otherUserData = {};
                    if (otherUserId) {
                        const userDoc = await getDoc(doc(db, 'users', otherUserId));
                        if (userDoc.exists()) {
                            otherUserData = userDoc.data();
                        }
                    }

                    conversationList.push({
                        chatId: docSnap.id,
                        name: otherUserData.firstName + ' ' + otherUserData.lastName,
                        avatar: otherUserData.avatar,
                        lastUpdated: data.lastUpdated?.toDate?.() || null
                    });
                }
                //console.log(conversationList);
                //alert('Recorded');
                this.conversations = conversationList;
            } catch (err) {
                console.error('Error fetching latest conversations:', err);
            }
        },
        logout(){            
            localStorage.removeItem('token')            
            this.$router.go('/login')
        }        
    },
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('keydown', this.handleKeyDown);

        this.fetchOnlineUsers();
        //*
        if (this.id) {            
            this.fetchLatestConversations(); // ✅ only call after user ID is available
        } else {
            // Not logged in
            console.warn('No user is signed in');
        }
        //*/
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('keydown', this.handleKeyDown);
    }
}
</script>

<style>
/* Mobile-only toggle button */
.mobile-search-toggle {
  display: none;
}

@media (max-width: 767.98px) {
  .mobile-search-desktop-form {
    display: none;
  }

  .mobile-search-toggle {
    height:10px;
    display: inline-block;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
  }
}

/* Modal Overlay */
.mobile-search-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* Modal Search Box */
.mobile-search-box {
  background: white;
  padding: 1.5rem;
  border-radius: 0.5rem;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
}

.mobile-search-box input {
  width: 80%;
  padding: 0.6rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 0.3rem;
  margin-right: 0.5rem;
}

.mobile-search-box button {
  background: #007bff;
  border: none;
  color: white;
  padding: 0.6rem 1rem;
  border-radius: 0.3rem;
  cursor: pointer;
}

</style>
    